module.exports = __webpack_public_path__ + "img/placeholder.558ec3a7.png";